import React, { useState, useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { change_password, messageClear } from "../../store/reducers/authReducer";

const ChangePassword = () => {
  const { t } = useContext(LanguageContext);
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
  });
  const dispatch = useDispatch();
  const { loader: loading, successMessage, errorMessage } = useSelector(
    (state) => state.auth
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        change_password({
          oldPassword: formData.old_password,
          newPassword: formData.new_password,
        })
      );
    } catch (err) {
      // errors are handled via state and effect below
    }
  };

  // show toasts based on reducer messages
  React.useEffect(() => {
    if (successMessage) {
      toast.success(successMessage || t("update"));
      dispatch(messageClear());
      setFormData({ old_password: "", new_password: "" });
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch, t]);

  return (
    <div className="p-4 bg-white max-w-md mx-auto">
      <h2 className="text-xl text-slate-600 pb-5">
        {t("changePasswordTitle")}
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-1 mb-2">
          <label htmlFor="old_password">{t("oldPasswordLabel")}</label>
          <input
            type="password"
            id="old_password"
            name="old_password"
            placeholder={t("oldPasswordLabel")}
            className="outline-none px-3 py-1 border rounded-md text-slate-600"
            onChange={handleChange}
            value={formData.old_password}
            required
          />
        </div>
        <div className="flex flex-col gap-1 mb-4">
          <label htmlFor="new_password">{t("newPasswordLabel")}</label>
          <input
            type="password"
            id="new_password"
            name="new_password"
            placeholder={t("newPasswordLabel")}
            className="outline-none px-3 py-1 border rounded-md text-slate-600"
            onChange={handleChange}
            value={formData.new_password}
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-8 py-2 bg-purple-500 shadow-lg hover:shadow-purple-500/30 text-white rounded-md"
        >
          {loading ? t("updating") : t("update")}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
